import { render, staticRenderFns } from "./tabbar3.vue?vue&type=template&id=53b1d166&scoped=true&"
import script from "./tabbar3.vue?vue&type=script&lang=js&"
export * from "./tabbar3.vue?vue&type=script&lang=js&"
import style0 from "./tabbar3.vue?vue&type=style&index=0&id=53b1d166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b1d166",
  null
  
)

export default component.exports